<template>
<div v-if="user" class="view-navigation">
    <div class="navigation__header">
        <div class="user__info">
            <div class="user__avatar">
                <i class="fa-solid fa-circle-user"></i>
            </div>
            <div class="user__name">{{ user.name }} {{ user.surName }}</div>
        </div>
    </div>
    <div class="navigation__body">
        <ul class="navigation__list">
            <li><a v-bind:href="'/orders'"><i class="fa-solid fa-bag-shopping"></i> Pedidos</a></li>
            <li><a v-bind:href="'/user'"><i class="fa-solid fa-user"></i> Cadastro</a></li>
            <li><a v-bind:href="'/auth'"><i class="fa-solid fa-id-badge"></i> Autenticação</a></li>
            <li><a v-bind:href="'/logout'"><i class="fa-solid fa-right-from-bracket"></i>Sair</a></li>
        </ul>
    </div>
</div>
</template>


<script setup>
import { ref, onMounted } from 'vue'
import Auth from '@/utils/auth.js';

const user = ref(null)

async function loadUser() {
    user.value = Auth.getCurrentUser()
}

onMounted(async () => {
    loadUser()
})
</script>